import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ScreenSizes } from 'src/app/common/utils/helpers';
import { DEVICE_DETECTOR_SERVICE } from 'utils/device-detector';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  usingCapacitor = false;
  deviceInfo: DeviceDetectorService;
  win: Window;
  doc: Document;
  pltId: NonNullable<unknown>;
  constructor() {
    this.doc = inject(DOCUMENT);
    this.win = inject(WINDOW);
    this.pltId = inject(PLATFORM_ID);
    this.deviceInfo = inject(DEVICE_DETECTOR_SERVICE);
  }

  isMobileNotIpad = () =>
    isPlatformBrowser(this.pltId)
      ? this.win.matchMedia('(max-width: ' + (ScreenSizes.SM - 1) + 'px)').matches
      : this.isServerMobileNotIpad(this.win.navigator.userAgent);

  isMobileIpad = () =>
    isPlatformBrowser(this.pltId)
      ? this.win.matchMedia('(max-width: ' + (ScreenSizes.MD - 1) + 'px)').matches &&
        this.win.matchMedia('(min-width: ' + ScreenSizes.SM + 'px)').matches
      : this.isServerMobileIpad(this.win.navigator.userAgent);

  isMobile = () =>
    isPlatformBrowser(this.pltId)
      ? this.win.matchMedia('(max-width: ' + (ScreenSizes.MD - 1) + 'px)').matches
      : this.isServerMobile(this.win.navigator.userAgent);

  isMobileOrIpad = () =>
    isPlatformBrowser(this.pltId)
      ? this.win.matchMedia('(max-width: ' + (ScreenSizes.MD + 1) + 'px)').matches
      : this.isServerMobileOrIpad(this.win.navigator.userAgent);

  isSafari = () => {
    const ua = this.win.navigator.userAgent;
    const webkit =
      (!!ua.match(/WebKit/i) || !!ua.match(/AppleWebKit/i)) && !ua.match(/Chrome/i) && !ua.match(/Chromium/i);
    return !!webkit;
  };

  isMobileSafari = () => {
    const ua = this.win.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i) || (!!ua.match(/Macintosh/i) && 'ontouchend' in this.doc);
    const webkit =
      (!!ua.match(/WebKit/i) || !!ua.match(/AppleWebKit/i)) && !ua.match(/Chrome/i) && !ua.match(/Chromium/i);
    return !!(iOS && webkit);
  };

  isCustomSmallScreen = (width: number) => this.win.matchMedia(`(max-width: ${width}px)`).matches;

  isPlatformBrowser = () => isPlatformBrowser(this.pltId);
  isPlatformServer = () => isPlatformServer(this.pltId);

  private isServerMobile = (ua: string) => this.deviceInfo.isMobile(ua) || this.deviceInfo.isTablet(ua);
  private isServerMobileIpad = (ua: string) => this.deviceInfo.isTablet(ua);
  private isServerMobileNotIpad = (ua: string) => this.deviceInfo.isMobile(ua);
  private isServerMobileOrIpad = (ua: string) => this.deviceInfo.isMobile(ua) || this.deviceInfo.isTablet(ua);
}
